import React from "react";

import LookupsAPI from "../API/lookups.api";
import { GLOBAL_ID } from "./constants";

const reformatCountry = (country) =>
    country.searchable
        ? country
        : {
              searchable: country?.label,
              value: country?.value,
              label: (
                  <>
                      <div
                          className={
                              country.value === GLOBAL_ID
                                  ? "fas fa-globe-americas"
                                  : `flag-icon flag-icon-${country.alpha2Code?.toLowerCase()}`
                          }
                      ></div>
                      {` ${country?.label}`}
                  </>
              ),
              code: country?.alpha2Code,
          };

const getCountryWithFlag = (country) => {
    return (
        <>
            <div
                className={
                    country.value === GLOBAL_ID
                        ? "fas fa-globe-americas"
                        : `flag-icon flag-icon-${country.alpha2Code.toLowerCase()}`
                }
            ></div>
            {` ${country?.label}`}
        </>
    );
};

const getCountriesDropdown = async (setter, includeGlobal = false) => {
    try {
        const result = await LookupsAPI.getCountries(includeGlobal);
        const selectReady = [];
        result.forEach((country) => {
            selectReady.push(reformatCountry(country));
        });
        setter(selectReady);
    } catch (e) {
        console.log(e);
    }
};

export { getCountriesDropdown, reformatCountry, getCountryWithFlag };
